import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  checkBox: {
    display: 'flex',
    alignItems: 'center',
  },
  noBorderCard: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: 'none',
    },
  },
}))

export default styles
